// extracted by mini-css-extract-plugin
module.exports = {"PricesTabs":"Prices_PricesTabs__b6VLa","active":"Prices_active__ic9If"};